module.exports = __webpack_public_path__ + "media/images/games/k2gender/catstr-417e2f85b76e0d75f1d2ed575e2b67e9.png";